import React from 'react';
import { motion } from 'framer-motion';
import { contact, socialLinks } from '../../data/portfolioData';

export default function ContactSection() {
  return (
    <section id="contact" className="mx-auto w-full max-w-7xl px-4 pb-20 pt-20 sm:px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.55 }}
        className="glass-card relative overflow-hidden"
      >
        <div className="absolute -right-24 -top-24 h-56 w-56 rounded-full bg-violet-500/30 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 h-56 w-56 rounded-full bg-cyan-500/30 blur-3xl" />

        <div className="relative z-10 flex flex-col gap-7 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-cyan-300">Let&apos;s Build</p>
            <h2 className="mt-3 font-display text-3xl font-bold text-white sm:text-5xl">Ready for a Premium Build?</h2>
            <p className="mt-4 text-sm leading-relaxed text-slate-300 sm:text-base">{contact.availability}</p>
            <p className="mt-2 text-sm text-slate-400">Location: {contact.location}</p>
          </div>

          <div className="flex flex-col gap-4">
            <a
              data-magnetic
              href={`mailto:${contact.email}`}
              className="rounded-full bg-neon px-6 py-3 text-center text-xs font-bold uppercase tracking-[0.16em] text-white shadow-glow"
            >
              {contact.email}
            </a>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((item) => (
                <a
                  key={item.label}
                  data-magnetic
                  href={item.url}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full border border-white/20 bg-white/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-slate-100"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
